import 'modernizr'; // eslint-disable-line
import '../vendor/bootstrap';

import tracking from '../modules/tracking';
import videoOverlay from '../modules/videoOverlay';
import slider from '../modules/slider';
import toggle from '../modules/toggle';
import cookieBar from '../modules/cookieBar';
import embedWrap from '../modules/embedWrap';
import alert from '../modules/alert';
import accessibility from '../modules/accessibility';
import mediaRow from '../modules/mediaRow';
import controlledInput from '../modules/controlledInput';
// import gaTracking from '../modules/gaTracking';

const general = () => {
  tracking.initialize();
  accessibility.initialize();
  videoOverlay.initialize();
  slider.initialize();
  toggle.initialize();
  cookieBar.initialize();
  embedWrap();
  alert.initialize();
  mediaRow.initialize();
  controlledInput.initialize();
  // gaTracking();
};

export default general;
